export function updateEntitySchemaForFinalURLSuffix(entitySchema) {
  const entitySchemaCopy = entitySchema;

  entitySchemaCopy.properties.FinalUrlSuffix.operators
  = ['contains', 'doesnotcontain', 'startswith', 'eq'];

  return entitySchemaCopy;
}
